import { useEffect } from "react";

const SITE = "https://kleen-g.com";

function upsertMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

/** Sets a unique <title>, meta description, canonical URL and robots directive per page. */
export function useSeo({ title, description, path, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("description", description);
    upsertLink("canonical", path ? `${SITE}${path}` : undefined);
    upsertMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    return () => { upsertMeta("robots", "index, follow"); };
  }, [title, description, path, noindex]);
}
